import { render } from "./designImagePreview.vue?vue&type=template&id=bd9a72c4&scoped=true"
import script from "./designImagePreview.vue?vue&type=script&lang=js"
export * from "./designImagePreview.vue?vue&type=script&lang=js"

import "./designImagePreview.vue?vue&type=style&index=0&id=bd9a72c4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd9a72c4"]])

export default __exports__